/*
 * File: position.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 13, 2024 at 9:43 AM
 * Copyright © 2024 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 3, 2025 at 11:09 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Utilities
 */

export const scrollPageTo = (x, y, options = {}) => {
	if (typeof window !== 'undefined') {
		window.scroll({ top: y, left: x, ...options });
	}
};

export const scrollPageToHash = (hash) => {
	const id = hash.replace('#', '');
	const element = document.getElementById(id);
	if (element) {
		element.scrollIntoView({ behavior: 'smooth' });
	} else {
		scrollPageTo(0, 0, { behavior: 'smooth' });
	}
};

export const leftCenterPosition = (clientRect) => (clientRect?.left || 0) + ((clientRect?.width || 0) / 2);

export const topCenterPosition = (clientRect) => (clientRect?.top || 0) + ((clientRect?.height || 0) / 2);
